import classNames from 'classnames';
import React from 'react';
import css from './FloatingActionButton.module.scss';

export default function FloatingActionButton({ className, ...props }: React.ButtonHTMLAttributes<HTMLButtonElement>) {
   return <button className={classNames(css.floatingActionButton, className)} {...props} />
}
